import { Icon, type TIconProps } from '~/components/icon'
import type { TIconSizes } from '~/components/icon/types'
import { useInputPasswordProps } from '../../hooks'

export const InputPasswordIcon = ({
  symbol = 'rdicon-default',
  testID,
  ...props
}: TIconProps) => {
  const { hasError, disabled, readonly, size } = useInputPasswordProps()

  const renderIconColor = (): TIconProps['color'] => {
    if (disabled) {
      return 'colorTextNeutralDisabled'
    }
    if (readonly) {
      return 'colorTextNeutralReadonly'
    }
    return 'colorTextNeutralDefault'
  }

  const renderIconSize = (): TIconSizes => {
    if (size === 'md') {
      return 'extra-small'
    }
    return 'small'
  }

  return (
    <Icon
      symbol={symbol}
      testID={testID}
      size={renderIconSize()}
      color={renderIconColor()}
      {...props}
    />
  )
}
